
export class RoundParameters {
	roundId: number = 0;
	dispatchId: number = 0;
	locCode: string = '';
	planPeriod: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
}